import React, { useEffect, useState } from "react";
import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import { ModuleAccess } from "utils/moduleaccess";
import { toast } from "react-toastify";
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";
import { Col, Row } from "reactstrap";
import { cellRendererCheck, dateFormate } from "utils/columns";

let rowForEdit = {};

const LocationTable = ({
  data,
  onExport,
  filters,
  totalSize,
  onPageChange,
  coveredEntityID,
  refetch,
  tenantID,
  setLoading,
  researchNeededCount,
  eligibleCount,
  inEligibleCount,
  onSearchColumnFilters,
  reset,
  collapseSider,
  resetFlag,
  SetResetFlag,
  toggleSider,
}) => {
  const API = useAxios();
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });
  useEffect(() => {
    setHasExportPermission(ModuleAccess("SL", "EXP"));
  }, []);
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
  }, [data]);

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setState({
      tableData: [],
      backUpData: [],
    });
    rowForEdit = {};
  }, [reset]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  const saveUpdateRow = async () => {
    setLoading(true);
    const payload = { ...rowForEdit };
    payload.eligibleFlag =
      payload.eligibleFlag === null ? "N" : payload.eligibleFlag;
    delete payload.isEdit;
    try {
      const result = await API.post(
        `/${tenantID}/CEServiceLocation/Update/${coveredEntityID}`,
        payload
      );
      if (result) {
        if (result.data) {
          if (onSearchColumnFilters) {
            onSearchColumnFilters(state.filters);
          }
          let param = {};
          param.CoveredEntityId = coveredEntityID;
          param.ActionType = "LocationResearchNeeded";
          const { data } = await API.post(
            `Dashboard/${tenantID}/Taskboard/updatetaskboard`,
            param
          );
        } else {
          toast.error("Service location reprocess is pending");
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setState({
      backUpData: tempData,
      tableData: tempData,
    });
  };

  const cellRenderEdit = (row) => {
    var hasPermission = ModuleAccess("SL", "ED");
    if (hasPermission) {
      return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} />;
    }
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      cellRenderer: (row) => cellRenderEdit(row),
      action: true,
    },
    {
      dataField: "serviceLocationName",
      text: "Service Location Name",
      sort: true,
      width: 165,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: false,
    },
    {
      dataField: "eligibleFlag",
      text: "Eligible Flag",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "switch", true),
      edit: true,
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "textarea"),
      edit: true,
    },
    {
      dataField: "source",
      text: "Source",
      sort: false,
      width: 144,
      show: true,
      hideColFilter: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdBy",
      text: "Created By",
      sort: false,
      width: 144,
      show: true,
      hideColFilter: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 144,
      show: true,
      hideColFilter: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const handleFilterCancel = () => {
    refetch(true);
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setState({
        filters: filter,
      });
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    let locationfilters = { ...filter, currentPage: colFilter.currentPage }
    setState({
      filters: locationfilters,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const { filters: colFilter, backUpData } = state;
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="">
          <h5 className="f-16 text-primary font-weight-700 m-0">Locations Count ({totalSize}) </h5>
        </div>
        <div>
          <Row className="d-flex justify-content-between">
            <Col xs="auto p-0 d-flex">
              <div>
                <span style={{ color: "#757575", fontWeight: "600" }}>
                  Research Required :{" "}
                </span>{" "}
                <span
                  style={{
                    color: "#702C62",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  {" "}
                  {researchNeededCount}
                </span>
                &nbsp;&nbsp;
                <span style={{ color: "#757575", fontWeight: "600" }}>
                  Eligible :{" "}
                </span>{" "}
                <span
                  style={{
                    color: "#702C62",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  {" "}
                  {eligibleCount}
                </span>
                &nbsp;&nbsp;
                <span style={{ color: "#757575", fontWeight: "600" }}>
                  Ineligible :{" "}
                </span>{" "}
                <span
                  style={{
                    color: "#702C62",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  {inEligibleCount}
                </span>
                &nbsp;&nbsp;
              </div>
              <div
                className="togglesider ps-3 ms-3"
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={backUpData.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="location-table"
          fixedColumn
          data={backUpData}
          columns={columns}
          onPageSizeChange={onPageSizeChange}
          pageSize={colFilter.pageSize}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          onExport={onExport}
          hasNoEligibility={false}
          hasPagination
          onPageChange={onHandlePageChange}
          currentPage={colFilter.currentPage}
          totalRecords={totalSize}
          filters={state.filters}
          handleSort={handleSort}
          researchNeededCount={researchNeededCount}
          eligibleCount={eligibleCount}
          inEligibleCount={inEligibleCount}
          hasExportPermission={hasExportPermission}
          collapseSider={collapseSider}
          resetFlag={resetFlag}
          SetResetFlag={SetResetFlag}
          toggleSider={toggleSider}
        />
      </div>
    </div>
  );
};

export default LocationTable;
